<template>
    <div class="ckeditor">
        <textarea
          :name="name"
          :id="id"
          :value="value"
          :types="types"
          :config="config">
        </textarea>
    </div>
</template>

<script>
let inc = new Date().getTime()

export default {
  name: "ckeditor",
  props: {
    name: {
      type: String,
      default: () => `editor-${++inc}`
    },
    value: {
      type: String
    },
    id: {
      type: String,
      default: () => `editor-${inc}`
    },
    types: {
      type: String,
      default: () => `classic`
    },
    config: {
      type: Object,
      default: () => ({
        toolbar: [ 'headings', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
        heading: {
          options: [
            {modelElement: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {modelElement: 'heading1', viewElement: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {modelElement: 'heading2', viewElement: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'}
          ]
        }
      })
    }
  },
  data () {
    return {
      editor: null,
      destroyed: false
    }
  },
  computed: {
    instance () {
      return this.editor
    }
  },
  watch: {
    value (val) {
      if (this.editor) {
        this.update(val)
      }
    }
  },
  mounted () {
    this.create()
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    create () {

      ClassicEditor
        .create(document.getElementById(this.id), this.config)
        .then(editor => {
          this.editor = editor;

          this.editor.setData(this.value);
          this.editor.document.on('changesDone', this.onChange);
          this.editor.document.on('blur', this.onBlur);
          this.editor.document.on('focus', this.onFocus);
        })
        .catch(error => {
          console.error(error);
        });
    },
    update (val) {
      let html = this.editor.getData();
      if (html !== val) {
        this.editor.setData(val)
      }
    },
    destroy () {
      if (!this.destroyed) {
        this.editor.destroy();
        this.onBlur();
        this.destroyed = true
      }
    },
    onChange () {
      let html = this.editor.getData();
      if (html !== this.value) {
        this.$emit('input', html)
      }
    },
    onBlur () {
      this.$emit('blur', this.editor)
    },
    onFocus () {
      this.$emit('focus', this.editor)
    }
  }
}
</script>
<style>
.ckeditor::after {
  content: "";
  display: table;
  clear: both;
}
</style>
